import { Suspense, lazy } from "react";

import type { UUID } from "../../utils/uuid";
import type { FC } from "react";

export interface SurveyAlertWizardDialogContentProps {
  open: boolean;
  onClose: () => void;
  surveyId: UUID;
}

const LazySurveyAlertWizardDialogContent = lazy(() =>
  import("../schedule/components/survey-alert-wizard-dialog").then((module) => ({
    default: module.SurveyAlertWizardDialogContent,
  })),
);

export const SurveyAlertWizardDialogContentSlot: FC<SurveyAlertWizardDialogContentProps> = (
  props,
) => (
  <Suspense fallback={null}>
    <LazySurveyAlertWizardDialogContent {...props} />
  </Suspense>
);
